import CompassIcon from "@/components/shared/icons/CompassIcon.vue";
import MagnifyingGlassWithBarsIcon from "@/components/shared/icons/MagnifyingGlassWithBarsIcon.vue";
import TeamIcon from "@/components/shared/icons/TeamBasedIcon.vue";
import UserSquareIcon from "@/components/shared/icons/UserSquareIcon.vue";
import SchoolIcon from "@/components/svg-icons/SchoolIcon.vue";

import HomeIcon from "@/components/shared/icons/HomeIcon.vue";
import SearchCheck from "@/components/shared/icons/SearchCheck.vue";
import BrowseActivityIcon from "@/components/svg-icons/BrowseActivityIcon.vue";
import { CURRICULUM_INTEGRATION_ROUTES, PERMISSIONS } from "@/constants";
import { useGetCitiesData } from "@/providers/cities/useGetCitiesData.js";
import { useGetCountriesData } from "@/providers/countries/useGetCountriesData.js";
import { useGetEducationLevelsData } from "./composables/useGetEducationLevelsData.js";
import { useGetHostInstitutionsData } from "./composables/useGetHostInstitutionsData.js";
import { useGetLanguagesData } from "./composables/useGetLanguagesData.js";

export const CI_LINKS_COURSE_APPROVAL = "global-course-navigator-link";

export const HOME_CARDS = [
  {
    icon: SchoolIcon,
    title: "Aligning Study Abroad with Academic Goals",
    description: "Ensuring programs enhance—not disrupt—students’ progress toward graduation.",
  },
  {
    icon: TeamIcon,
    title: "Engaging Faculty",
    description: "Partnering to design programs that integrate study abroad into learning outcomes.",
  },
  {
    icon: UserSquareIcon,
    title: "Empowering Students",
    description: "Offering tailored options that resonate with their degree requirements and personal goals.",
  },
];

export const WHAT_TO_EXPECT_CARDS = [
  {
    icon: CompassIcon,
    title: "Global Course Navigator",
    description:
      "Harness the power of AI to recommend course equivalencies that expand opportunities for students and streamline curriculum planning.",
  },
  {
    icon: MagnifyingGlassWithBarsIcon,
    title: "Actionable Data",
    description:
      "Summarize course approvals, stay ahead of expiring classes, and keep track of key metrics with a single, intuitive interface.",
  },
];

export const queryKeys = {
  courseEquivalencies: {
    all: ["courseEquivalencies"],
    list: (page, search, entityId, filters) => ["courseEquivalencies", "list", page, search, entityId, filters],
    detail: (id) => ["courseEquivalencies", "detail", id],
  },
};

export const INITIAL_INFERENCE_FILTERS = {
  countries: [],
  cities: [],
  hostInstitutions: [],
  languagesOfInstruction: [],
  courseLevels: [],
};

export const INFERENCE_FILTERS = [
  {
    paramName: "city",
    title: "City",
    component: "InferenceMultiSelect",
    filterPath: "cities",
    getter: (limit, page, city_ascii) => useGetCitiesData({ limit, page, city_ascii }),
    displayName: "city",
  },
  {
    paramName: "country",
    title: "Country",
    component: "InferenceMultiSelect",
    filterPath: "countries",
    getter: (limit, page, q) => useGetCountriesData({ limit, page, q, useQueryOptions: { staleTime: 0 } }),
    displayName: "name",
  },
  {
    paramName: "host_institution",
    title: "Host Institution",
    component: "InferenceMultiSelect",
    filterPath: "hostInstitutions",
    getter: useGetHostInstitutionsData,
    displayName: "name",
  },
  {
    paramName: "required_language",
    title: "Required Language",
    component: "InferenceMultiSelect",
    filterPath: "languagesOfInstruction",
    getter: useGetLanguagesData,
    displayName: "value",
  },
  {
    paramName: "course_level",
    title: "Course Level",
    component: "InferenceMultiSelect",
    filterPath: "courseLevels",
    getter: useGetEducationLevelsData,
    displayName: "value",
  },
];

export const CURRICULUM_INTEGRATION_LINKS = [
  {
    id: "home-link",
    label: "Home",
    icon: HomeIcon,
    route: CURRICULUM_INTEGRATION_ROUTES.HOME,
  },
  {
    id: "dashboard-link",
    label: "Dashboard",
    icon: BrowseActivityIcon,
    route: CURRICULUM_INTEGRATION_ROUTES.DASHBOARD,
  },
  {
    id: "global-course-navigator-link",
    label: "Global Course Navigator",
    icon: SearchCheck,
    route: CURRICULUM_INTEGRATION_ROUTES.APPROVE_COURSES,
  },
];

export const CI_HOME_CTA_ARIA_LABEL = "View live course approvals in student search. Opens in a new tab";
